import React, { useEffect, useRef, useState } from 'react'
import './Worksheet.css'
import DeletedWorksheetTable from './DeletedWorksheetTable'
import HomeService from '../../../Services/HomeService';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
const DeletedWorksheet = () => {
    const childRef = useRef();

    const userRole = localStorage.getItem("role");
    const userCity = localStorage.getItem("city");
    const loggedUserID = localStorage.getItem("uid");
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(userCity || "");
    const [propertyTypes, setPropertyTypes] = useState([]);
    const [selectedPropertyType, setSelectedPropertyType] = useState("");

    const [localities, setLocalities] = useState([]);
    const [selectedLocality, setSelectedLocality] = useState("");

    const[apartments,setApartments]=useState([])
    const [selectedApartment,setSelectedApartment]=useState("")

    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(false)
    // Fetch cities
    const fetchCities = async () => {
        try {
            const res = await HomeService.getCities();
            console.log("HYT31", res.data);

            if (res?.data) {
                setCities(res.data);
                if (userCity) {
                    setCities([res.data.find(item => item._id === userCity)])
                } else {
                    setCities(res.data);
                }
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    }

    const addNewRow = () => {
        selectedCity && selectedPropertyType ? childRef.current.handleInsertFirst() : toast.error("Choose City and Property Type")
    }

    const saveAllRows = () => {
        selectedCity && selectedPropertyType ? childRef.current.saveAll() : toast.error("Choose City and Property Type")
    }
    


    const deleteAllNewEntry = () => {
        childRef.current.handleDeleteAllNewEntry("$", selectedCity, selectedPropertyType)
    }


    // Fetch property types
    const fetchPropertyTypes = async () => {
        try {
            const res = await HomeService.getPropertyTypes();
            if (res?.data) {
                setPropertyTypes(res.data);
            }
        } catch (error) {
            console.error("Error fetching property types:", error);
        }
    }

    // Fetch properties
    const fetchProperties = async () => {
        setLoading(true)
        try {
            const res = await HomeService.getDeletedProperties();
            if (res?.data) {

                let filteredData = []
                // if (selectedCity) {
                //     filteredData = res.data.filter((item) => item?.city?._id === selectedCity)
                // }
                // if (selectedPropertyType) {
                //     filteredData = (filteredData.filter((item) => item?.propertytype?._id === selectedPropertyType))
                // }

                if (selectedCity && selectedPropertyType) {
                    filteredData = res.data.filter((item) => item?.city?._id === selectedCity && item?.propertytype?._id === selectedPropertyType)
                }
                if (selectedLocality) {
                    filteredData = filteredData.filter((item) => item?.locality?._id === selectedLocality)
                }
                if(selectedApartment){
                    filteredData = filteredData.filter((item) => item?.aptName?.toLowerCase()?.includes(selectedApartment.toLowerCase()))
                }
                console.log("CFR86", filteredData, selectedCity, selectedPropertyType, selectedLocality);
                setLoading(false)
                setProperties(filteredData)
            }
        } catch (error) {
            console.error("Error fetching property types:", error);
        }
    }

    const getCityNameById = (id) => {
        const city = cities.find(city => city._id === id);
        return city?.name
    }

    const getPropertyTypeNameById = (id) => {
        const propertyType = propertyTypes.find(type => type._id === id);
        return propertyType?.propertyType
    }


    // Fetch localities
    const fetchLocalities = async () => {
        try {
            const res = await HomeService.getLocalities();
            console.log("HYT71", res);

            if (res?.data) {
                setLocalities(res.data.filter((item) => item?.city?._id === selectedCity));
            }
        } catch (error) {
            console.error("Error fetching localities:", error);
        }
    }

    // Fetch Apartments
      const fetchApartments = async () => {
        try {
          const res = await HomeService.getApartment();
          console.log("HYT86", res.data);
    
          if (res?.data) {
            setApartments(res.data.filter((item) => item?.city._id === selectedCity && item?.locality?._id === selectedLocality));
          }
        } catch (error) {
          console.error("Error fetching apartments:", error);
        }
      }

    useEffect(() => {
        fetchCities()
        fetchPropertyTypes()
        // fetchProperties()
    }, [])

    useEffect(() => {
        fetchLocalities()
        fetchApartments()
        fetchProperties()
    }, [selectedCity, selectedPropertyType, selectedLocality,selectedApartment])



    return (
        <>
            <div className="main_wrap">
                <div className='work_sheet_header'>
                    <div className='input_wrapper'>
                        {/* <div className='show_entries'>
                            <p>Show</p>
                            <select>
                                <option value={'100'}>100</option>
                            </select>
                            <p>Entries</p>
                        </div> */}

                        <div className='show_entries'>
                            <p>Property Type</p>
                            <select
                                value={selectedPropertyType}
                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                            >
                                <option value="">---Select---</option>
                                {propertyTypes.map((type) => (
                                    <option key={type._id} value={type._id}>
                                        {type.propertyType}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className='show_entries'>
                            <p>City</p>
                            <select
                                value={selectedCity}
                                onChange={(e) => {
                                    setSelectedCity(e.target.value)
                                }}
                            >
                                <option value="">---Select---</option>
                                {cities.map((city, key) => (
                                    <option key={key} value={city._id}>
                                        {city.name}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className='show_entries'>
                            <p>Locality</p>
                            <select
                                value={selectedLocality}
                                onChange={(e) => {
                                    setSelectedLocality(e.target.value)
                                }}
                            >
                                <option value="">---Select---</option>
                                {localities.map((item, key) => (
                                    <option key={key} value={item._id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='show_entries'>
                            <p>Apartment</p>
                            <input
                                type="text"
                                name="aptName"
                                value={selectedApartment}
                                onChange={(e)=>{setSelectedApartment(e.target.value)}}
                            />
                            {/* <select
                                value={selectedApartment}
                                onChange={(e) => {
                                    setSelectedApartment(e.target.value)
                                }}
                            >
                                <option value="">---Select---</option>
                                {apartments.map((item, key) => (
                                    <option key={key} value={item.aptName}>
                                        {item.aptName}
                                    </option>
                                ))}
                            </select> */}
                        </div>

                    </div>
                    {/* <div style={{
                        display: 'flex',
                        columnGap: '10px'
                    }}>
                        <button className='new_btn' onClick={saveAllRows}>Save All</button>
                        <button className='new_btn' onClick={addNewRow}>Add New Row</button>
                        <button className='remove_btn' onClick={deleteAllNewEntry}>Remove all $</button>
                    </div> */}
                </div>
                <div className='data_table_Wrapper'>
                    <DeletedWorksheetTable ref={childRef} tableData={properties} pcity={selectedCity} ptype={selectedPropertyType} reload={fetchProperties} cityName={getCityNameById} propertyTypeName={getPropertyTypeNameById} loading={loading} />
                </div>
            </div>
        </>
    )
}

export default DeletedWorksheet
